module.exports = {
  game: 'Game',
  prize: {
      currencySymbol: '€',
      currencySymbolForPennies: '€'
  },
  jackpot: {
      won: 'JACKPOT WON',
      notWon: 'No jackpot winners this game',
      title: 'Jackpot'
  },
  winners: {
      gameWinnersModalTitle: 'Winners',
      previousGameWinners: 'Past 10 Winners',
      previousJackpotWinners: 'Past 10 Jackpot Winners',
      previousBonusGameWinners: 'Past 10 Bonus Game Winners',
      previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
      previous100GameWinners: 'Past 100 Winners',
      tableHeaders: {
        gameId: 'Game Id',
        stamp: 'Stamp',
        winners: 'Winners',
        room: 'Room'
      },
      winnerTemplate: '{username} - {prize}€ ',
      winnersWindow: {
        tableHeaders: {
          game: 'Game',
          username: 'Name',
          prize: 'Prize'
        },
        freeze: 'freeze',
        title: 'Game Winners',
        copy: 'Copy'
      },
      popup: {
        title: 'Parabéns!',
        message: '{username} ganhou {prize} em {gameName}',
        extendedMessage: '{username} ganhou {prize} em {gameName} {prizeType}'
      }
  },
  hamsterRace: {
      lastEigthWinnersTitle: 'Last 8 Winners',
      firstPlace: '1st',
      hamster: 'Hamster',
      wins: 'Wins',
      winners: {
        tableHeaders: {
          winningHamster: 'Winning Hamster'
        }
      }
  },
  rollercoaster: {
      lastSixCallsTitle: 'Last 6 Calls'
  },
  arcade: {
    winners: {
      tableHeaders: {
        winnerName: 'Winner Name',
        gameName: 'Game Name',
        prize: 'Prize',
        stamp: 'Stamp'
      }
    },
    gameNameFormat: '{gameName}'
  },
  quizQuids: {
    tableHeaders: {
      winnerName: 'Winner Name',
      chatModeratorName: 'Chatmod Name',
      stamp: 'Stamp'
    }
  },
  pictureBingo: {
    winners: {
      tableHeaders: {
        theme: 'Theme'
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/pt/game.js
// module id = SbhZ
// module chunks = 1